import { IsArray, IsDate, IsDecimal, IsEnum, IsObject, IsString } from "class-validator";
import { IsBigInt } from "../decorators/applicationId.decorator";
import { BillingIntervalInMonths, ConsumptionPlan, PaymentStatus } from "../models/subscription.model";
import { GetAddonItemWithoutPriceDto, ProductConfigurationDto } from "./createSubscriptionAddOn.dto";
import { Transform } from "class-transformer";

export enum SubscriptionStatus {
  trial = "trial",
  active = "active",
  canceled = "canceled",
  pending_upgrade = "pending_upgrade",
  suspended = "suspended",
  pending_downgrade = "pending_downgrade"
}

export enum AgreementStatus {
  "accepted" = "accepted",
  "rejected" = "rejected",
  "actionRequired" = "actionRequired"
}

export class SubscriptionDto {
  @IsBigInt()
  id!: bigint;

  @IsEnum(SubscriptionStatus)
  status!: SubscriptionStatus;

  @IsEnum(Object.keys(ConsumptionPlan))
  plan!: ConsumptionPlan;

  @IsDecimal()
  price!: number;

  @IsEnum(BillingIntervalInMonths)
  @Transform(({ value }) => (typeof value === "string" ? parseInt(value) : value))
  billingIntervalInMonths!: BillingIntervalInMonths;

  @IsArray()
  payments: Payment[] = [];

  @IsDate()
  endDate!: Date | null;

  @IsDate()
  startDate!: Date | null;

  @IsEnum(Object.keys(AgreementStatus))
  agreement!: AgreementStatus;

  @IsObject()
  addons!: GetAddonItemWithoutPriceDto;

  @IsArray()
  productConfiguration!: ProductConfigurationDto[];

  constructor(partial: Partial<SubscriptionDto>) {
    Object.assign(this, partial);
  }
}

export class Payment {
  @IsBigInt()
  id!: bigint;

  @IsDecimal()
  price!: number;

  @IsEnum(Object.keys(PaymentStatus))
  status!: PaymentStatus;

  @IsString()
  transactionId?: string | undefined;

  constructor(partial: Partial<Payment>) {
    Object.assign(this, partial);
  }
}
